import { useEffect, useState } from "react"
import { createBotPackage, deleteBotPackage, editBotPackage, getBotPackageList } from "../../services/botPackagesApis"
import Table from "../Table"
import MyModal from "../MyModal"
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai"
import actionHelper from "../../lib/actionHelper"
import { toast } from "react-toastify"
import Input from "../Input"

const cols = [
    {
        name: "اسم پکیج",
        colSpan: 1,
    },
    {
        name: "توضیحات",
        colSpan: 1,
    },

    {
        name: "تعداد روز",
        colSpan: 1,
    },
    {
        name: "قیمت به تومان",
        colSpan: 1,
    },
    {
        name: "",
        colSpan: 1,
    },
]

const BotPackageEditModal = ({ user, packaage }) => {
    const [isOpen, setIsOpen] = useState(false)
    const toggleModal = () => setIsOpen(!isOpen)

    const submitHandler = (e) => {
        e.preventDefault()
        toggleModal()

        const form = new FormData(e.target)
        const data = {
            packageId: packaage.id,
            packageDescription: form.get("description"),
            packageDays: form.get("days"),
            packageAmount: form.get("amount"),
            packageForAdmin: form.get("for-admin") == "on" ? true : false,
            packageType: form.get("package-bot-type") == "on" ? "youtube" : "normal",
        }
        toast.promise(editBotPackage(data), {
            pending: "درحال ویرایش پکیج",
            success: "ویرایش شد",
        })
    }

    return (
        <>
            <button
                onClick={toggleModal}
                className="flex rounded-md m-2 select-none focus:outline-none focus:shadow-outline"
            >
                <AiOutlineEdit size="1.7em" className=" hover:fill-yellow-400" />
            </button>
            <MyModal width="400px" height="400px" isOpen={isOpen} toggleModal={toggleModal}>
                <form className="mt-5" onSubmit={submitHandler}>
                    <div>
                        <Input
                            label="نام پکیج"
                            type="text"
                            name="package-name"
                            placeholder="نام پکیج"
                            required={true}
                            defaultValue={packaage.package_name}
                            disabled={true}
                        />
                        <span id="packageNameLabel">
                            <div class="show_info text-sm text-red-400">نامعتبر</div>
                        </span>
                    </div>
                    <div className="grid grid-cols-2 gap-5">
                        <div>
                            <Input
                                label="تعداد روز"
                                type="number"
                                name="days"
                                placeholder="تعداد روز"
                                defaultValue={packaage.package_days}
                            />
                        </div>
                        <div>
                            <Input
                                label="مقدار به تومان"
                                type="number"
                                name="amount"
                                placeholder="مثال: 10000"
                                defaultValue={packaage.package_amount}
                                required={true}
                            />
                        </div>
                    </div>

                    <div>
                        <Input
                            label="توضیحات"
                            name="description"
                            placeholder="توضیحات"
                            defaultValue={packaage.package_description}
                            required={true}
                        />
                    </div>
                    <div className="flex my-1">
                        <span class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">عادی</span>
                        <label dir="rtl" class="relative inline-flex items-center cursor-pointer">
                            <input
                                type="checkbox"
                                name="package-bot-type"
                                class="sr-only peer"
                                defaultChecked={packaage.package_bot_type == "youtube"}
                            />
                            <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none  peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                            <span class="mr-2 text-sm font-medium text-gray-300 dark:text-gray-300">یوتیوب</span>
                        </label>
                    </div>
                    <div class="flex items-start">
                        <div class="flex items-center h-5">
                            <input
                                id="foradmin"
                                aria-describedby="foradmin"
                                name="for-admin"
                                type="checkbox"
                                class="  focus:ring-3 focus:ring-blue-300 h-4 w-4 rounded"
                                defaultChecked={packaage.package_for_admin}
                            />
                        </div>
                        <div class="text-sm ml-3">
                            <label for="foradmin" class="font-medium text-gray-300">
                                فقط برای ادمین
                            </label>
                        </div>
                    </div>
                    <button type="submit" className="mt-5 styled-button success">
                        ساخت پکیج
                    </button>
                </form>
            </MyModal>
        </>
    )
}

const CreateBotPackageModal = ({ user, packageList }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [packageNameIsValid, setPackageNameIsValid] = useState(false)

    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        toggleModal()
        if (!packageNameIsValid) {
            toast.error("اسم پکیج معتبر نمیباشد")
        }
        const form = new FormData(e.target)
        const data = {
            packageName: form.get("package-name"),
            packageDescription: form.get("description"),
            packageDays: form.get("days"),
            packageAmount: form.get("amount"),
            packageForAdmin: form.get("for-admin") == "on" ? true : false,
            packageType: form.get("package-bot-type") == "on" ? "youtube" : "normal",
        }
        toast.promise(createBotPackage(data), { pending: "درحال ساخت", success: "ساخته شد" })
    }

    const handlePackageNameOnChange = (event) => {
        var packageNameLabel = document.getElementById("packageNameLabel")
        var packageName = event.target.value
        const usedPackageName = packageList?.find((item) => item.package_name === packageName)
        if (usedPackageName || packageName == "") {
            setPackageNameIsValid(false)
            packageNameLabel.innerHTML = '<div class="show_info text-sm text-red-400">نامعتبر</div>'
        } else {
            setPackageNameIsValid(true)
            packageNameLabel.innerHTML = '<div class="show_info text-sm text-green-400">معتبر</div>'
        }
    }

    return (
        <>
            <button onClick={toggleModal} className="flex gap-2 w-32 pl-2 styled-button mr-3 mb-3">
                <img src="assets/icons/square-plus.svg" className="h-5 w-5" />
                ساخت پکیج
            </button>
            <MyModal isOpen={isOpen} toggleModal={toggleModal} width="400px" height="400px">
                <form className="mt-5" onSubmit={handleSubmit}>
                    <div>
                        <Input
                            label="نام پکیج"
                            type="text"
                            name="package-name"
                            onChange={handlePackageNameOnChange}
                            placeholder="نام پکیج"
                            required={true}
                        />
                        <span id="packageNameLabel">
                            <div class="show_info text-sm text-red-400">نامعتبر</div>
                        </span>
                    </div>
                    <div className="grid grid-cols-2 gap-5">
                        <div>
                            <Input label="تعداد روز" type="number" name="days" placeholder="تعداد روز" />
                        </div>
                        <div>
                            <Input
                                label="مقدار به تومان"
                                type="number"
                                name="amount"
                                placeholder="مثال: 10000"
                                required={true}
                            />
                        </div>
                    </div>
                    <div>
                        <Input label="توضیحات" name="description" placeholder="توضیحات" required={true} />
                    </div>
                    <div className="flex my-1">
                        <span class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">عادی</span>
                        <label class="relative inline-flex items-center cursor-pointer">
                            <input dir="rtl" type="checkbox" name="package-bot-type" class="sr-only peer" />
                            <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none  peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                            <span class="mr-2 text-sm font-medium text-gray-300 dark:text-gray-300">یوتیوب</span>
                        </label>
                    </div>
                    <div class="flex items-start">
                        <div class="flex items-center h-5">
                            <input
                                id="foradmin"
                                aria-describedby="foradmin"
                                name="for-admin"
                                type="checkbox"
                                class="  focus:ring-3 focus:ring-blue-300 h-4 w-4 rounded"
                            />
                        </div>
                        <div class="text-sm ml-3">
                            <label for="foradmin" class="font-medium text-gray-300">
                                فقط برای ادمین
                            </label>
                        </div>
                    </div>
                    <button type="submit" className="mt-5 w-full styled-button success">
                        ساخت پکیج
                    </button>
                </form>
            </MyModal>
        </>
    )
}

const BotPackages = ({ user }) => {
    const [packageList, setPackageList] = useState(null)
    const updateUi = () => {
        if (user) {
            getBotPackageList(user.token)
                .then(({ data }) => {
                    data = data.map((p) => {
                        let obj = {
                            package_name: p.package_name,
                            package_description: p.package_description,
                            package_days: p.package_days ? p.package_days : "دائمی",
                            package_amount: p.package_amount.toLocaleString("en-US"),
                            more: (
                                <div className="flex gap-3 justify-end">
                                    <BotPackageEditModal user={user} packaage={p} />
                                    <button
                                        onClick={() =>
                                            toast
                                                .promise(deleteBotPackage(p.id), {
                                                    pending: "در حال حذف کردن پکیج",
                                                    success: "حذف شد",
                                                })

                                                .catch((err) => {
                                                    console.error(err)
                                                })
                                        }
                                        className="flex rounded-md m-2 select-none focus:outline-none focus:shadow-outline"
                                    >
                                        <AiOutlineDelete size="1.7em" className=" hover:fill-red-400" />
                                    </button>
                                </div>
                            ),
                        }
                        return obj
                    })
                    setPackageList(data)
                })
                .catch((err) => {
                    console.error(err)
                })
        }
    }

    useEffect(() => {
        updateUi()
        const interval = setInterval(updateUi, 5000)
        return () => clearInterval(interval)
    }, [])

    return (
        <>
            <CreateBotPackageModal user={user} packageList={packageList} />
            <Table cols={cols} rows={packageList} paging={{ maxRows: 10 }} />
        </>
    )
}

export default BotPackages
